import i18n, { InitOptions } from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const options: InitOptions = {
    // fallbackLng: {
    //     'en-US':['en'],
    //     'de-DE':['de'],
    //     default:['en']
    // },
    // lng: 'us',
    fallbackLng: 'us',
    debug: true,
    interpolation: {
        escapeValue: false,
    },
    detection: {
        // Detekcija jezika pomoću localStorage, cookies, itd.
        order: ['localStorage', 'cookie', 'navigator'],
        caches: ['localStorage'],
    },
    backend: {
        loadPath: '/locales/{{lng}}/translation.json',
    },
};

i18n.use(LanguageDetector).use(Backend).use(initReactI18next).init(options);

export default i18n;
